import { createContext } from "react";
import { packagesInitialState } from "./packagesInitialState";


const PackagesContext = createContext(packagesInitialState)

export default PackagesContext